// extracted by mini-css-extract-plugin
export default {"modalOverlay":"SuccessModal_modalOverlay__3TXvA","modalContent":"SuccessModal_modalContent__FH9Kl","modalButton":"SuccessModal_modalButton__WDeoh"};